import * as _ht from './_ht';
import * as _gv from './_gv';

const _tblz = { // https://docs.nativebase.io/default-theme
  rdz: { // red
    1: '#fee2e2',
    2: '#fecaca',
    3: '#fca5a5',
    4: '#f87171',
    5: '#ef4444',
    6: '#dc2626',
    7: '#b91c1c',
    8: '#991b1b',
    9: '#7f1d1d',
  },
  gnz: { // green
    1: '#dcfce7',
    2: '#bbf7d0',
    3: '#86efac',
    4: '#4ade80',
    5: '#22c55e',
    6: '#16a34a',
    7: '#15803d',
    8: '#166534',
    9: '#14532d',
  },
  lmz: { // lime
    1: '#ecfccb',
    2: '#d9f99d',
    3: '#bef264',
    4: '#a3e635',
    5: '#84cc16',
    6: '#65a30d',
    7: '#4d7c0f',
    8: '#3f6212',
    9: '#365314',
  },
  blz: { // blue
    1: '#dbeafe',
    2: '#bfdbfe',
    3: '#93c5fd',
    4: '#60a5fa',
    5: '#3b82f6',
    6: '#2563eb',
    7: '#1d4ed8',
    8: '#1e40af',
    9: '#1e3a8a',
  },
  ltz: { // light
    1: '#f3f4f6',
    2: '#e5e7eb',
    3: '#d1d5db',
    4: '#9ca3af',
    5: '#6b7280',
    6: '#4b5563',
    7: '#374151',
    8: '#1f2937',
    9: '#111827',
  },
  skz: { // smoke
    1: 'rgba(0,0,0,0.1)',
    2: 'rgba(0,0,0,0.2)',
    3: 'rgba(0,0,0,0.3)',
    4: 'rgba(0,0,0,0.4)',
    5: 'rgba(0,0,0,0.5)',
    6: 'rgba(0,0,0,0.6)',
    7: 'rgba(0,0,0,0.7)',
    8: 'rgba(0,0,0,0.8)',
    9: 'rgba(0,0,0,0.9)',
  },
  ywz: { // yellow
    1: '#fef9c3',
    2: '#fef08a',
    3: '#fde047',
    4: '#facc15',
    5: '#eab308',
    6: '#ca8a04',
    7: '#a16207',
    8: '#854d0e',
    9: '#713f12',
  },
} as _ht.dz;

const $cashz = {} as _ht.dz;

export const c = (
  tgt: _ht.s, 
) => {

  if ($cashz[tgt]) return $cashz[tgt];

  let _clr = 'red';

  if (tgt == 't') {
    _clr = 'transparent';
  }
  else {
    const _clrType = `${tgt.substring(0,2)}z`;
    if (_tblz[_clrType]) {
      const _gUserz = _gv.useUserz();
      const _clrLvl = ((_gUserz.crt.clrMode == 'd') ? (10 - Number(tgt[2])) : Number(tgt[2])); // colorMode を使用する場合、level を反転させれば良い
      if (_tblz[_clrType][_clrLvl]) {
        _clr = _tblz[_clrType][_clrLvl];
      }
    }
  }

  $cashz[tgt] = _clr;

  return _clr;
};
